import { render, staticRenderFns } from "./socialText.vue?vue&type=template&id=356b6a71&scoped=true&"
import script from "./socialText.vue?vue&type=script&lang=js&"
export * from "./socialText.vue?vue&type=script&lang=js&"
import style0 from "./socialText.vue?vue&type=style&index=0&id=356b6a71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b6a71",
  null
  
)

export default component.exports